import { Info } from 'lucide-react';

import approvedGif from '../../../../shared/assets/gif/approved.gif';
import expiredGif from '../../../../shared/assets/gif/expired.gif';
import misuseGif from '../../../../shared/assets/gif/misuse.gif';
import rejectedGif from '../../../../shared/assets/gif/rejected.gif';

const STATUS_CONFIG: Record<string, { gif: string; title: string; color: string; desc: string; isExpired?: boolean }> = {
  APPROVED: { gif: approvedGif, title: 'Login Approved', color: 'text-[#08A960]', desc: 'Your login has been approved successfully. You can now continue browsing at the Bluestone store.' },
  REJECTED: { gif: rejectedGif, title: 'Login Rejected', color: 'text-[#CA0704]', desc: 'The login request has been rejected. No action will be taken.' },
  REPORTED: { gif: misuseGif, title: 'Reported Misuse', color: 'text-[#E18726]', desc: 'Our security team has been notified. This login attempt has been blocked.' },
  EXPIRED: { gif: expiredGif, title: 'This login request has expired', color: 'text-[#022577]', desc: 'The approval window has passed. No action can be taken on this link.', isExpired: true },
};

export function StatusFeedbackScreen({ status }: { status: string }) {
  const config = STATUS_CONFIG[status];
  
  if (!config) return null;

  return (
    <div className="flex flex-col flex-1 w-full animate-in zoom-in-95 duration-500">
      <div className="flex-1 flex flex-col items-center justify-center gap-11 w-full mb-8">
        <div className="bg-white rounded-2xl flex flex-col items-center justify-center border border-[#E2E8F0] shadow-[0px_4px_4px_0px_#0000001A] w-full p-6 text-center">
          <img src={config.gif} alt={status} className="w-28 h-28 mb-2" />
          <h2 className={`${config.color} text-[22px] font-bold mb-4 tracking-wide`}>{config.title}</h2>
          <p className="text-[#45556C] leading-relaxed text-[15px]">{config.desc}</p>
        </div>
        {config.isExpired && <div className="w-full mb-8 px-1">
          <div className="bg-white rounded-[12px] border border-[#D9DBDB] shadow-[0px_4px_12px_0px_#0000001F] p-4 flex items-start gap-3">
            <Info className="w-[18px] h-[18px] text-[#011E37] shrink-0 mt-[2px]" strokeWidth={2} />
            <p className="text-[13px] text-[#011E37] tracking-wide leading-relaxed">
              Please contact the staff member to generate a new approval request.
            </p>
          </div>
        </div>}
      </div>
      
      {!config.isExpired &&
        <p className="text-center text-xs text-[#62748E] tracking-widest mt-auto mb-8 w-full">
          This link has been consumed and cannot be used again
        </p>
      }
    </div>
  );
}